import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d718c77"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-15",
  src: "/assets/logo.svg",
  width: "40"
}, null, -1))
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_5 = {
  key: 2,
  class: "d-flex align-center"
}
const _hoisted_6 = {
  key: 3,
  class: "d-flex align-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "buttons-page",
  class: "d-flex align-center"
}, null, -1))
const _hoisted_8 = { class: "d-flex align-center" }

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { MoleculeModalAlert } from '../molecules';
import { DashboardIcon, LogoutIcon, AtomButtonBar, SettingIcon, RelatoryIcon, RankingIcon } from '../atoms';
import { Authentication } from '@/store';
import { onMounted } from 'vue';
import ModalSolicitation from '@/pages/dashboard/components/ModalSolicitation.vue';
import { verifyPermission } from '@/utils/security';
import { Permissions } from '@/core/enum/permissions';

type MenuTitle = 'Dashboard' | 'Agentes' | 'Relatórios' | 'Leitos' | 'Configurações' | 'Serviços' | 'Análises' | 'Análise Agentes' | 'Análise Serviços';
interface MenuItem {
  title: MenuTitle;
  path?: string;
  hovered: boolean;
  options?: MenuTitle[]
}

const color = 'var(--components-main100)';
const colorHover = 'var(--components-main100)';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsBar',
  setup(__props) {

const showModalSolicitation = ref<boolean>(false);

const router = useRouter();
const showModal = ref<boolean>(false);
const hasPermission = ref<boolean>();
const isMaster = ref<boolean>(false);
const menuItems = ref<MenuItem[]>([
  {
    title: 'Dashboard',
    hovered: false,
    options: ['Serviços', 'Agentes'],
  },
  {
    title: 'Análises',
    hovered: false,
    options: ['Análise Serviços', 'Análise Agentes']
  },
  {
    title: 'Relatórios',
    hovered: false,
  },
  {
    title: 'Configurações',
    hovered: false,
  },
]);

const toggleHover = (menu: MenuTitle, value: boolean) => {
  const index = menuItems.value.findIndex((item) => item.title == menu);

  if (index === -1) return;

  menuItems.value[index].hovered = value;
};

onMounted(() => {
  hasPermission.value = verifyPermission([Permissions.MANAGER, Permissions.ADMIN])
  isMaster.value = verifyPermission([Permissions.MASTER]);
})

const filteredMenuItems = computed(() => {
  return isMaster.value ? menuItems.value.filter(item => item.title === 'Configurações') : menuItems.value;
});

function handleLogout() {
  Authentication.actions.logout();
  router.push({ name: 'Login' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      height: "100",
      style: {"padding":"0 50px 0 55px","background":"var(--background-surfacePrimary) !important"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo-link"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuItems.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.title,
              to: { name: item.options ? item.options[0] : item.title },
              class: _normalizeClass(["menu-option", {
          active: (_ctx.$route.name as MenuTitle) === item.title || item.options?.includes(_ctx.$route.name as MenuTitle)
        }]),
              onMouseover: ($event: any) => (toggleHover(item.title, true)),
              onMouseleave: ($event: any) => (toggleHover(item.title, false))
            }, {
              default: _withCtx(() => [
                (item.title == 'Dashboard' || item.title == 'Serviços' || item.title == 'Agentes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(DashboardIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == 'Dashboard' || _ctx.$route.name == 'Serviços' || _ctx.$route.name == 'Agentes' ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Análises' || item.title == 'Análise Serviços' || item.title == 'Análise Agentes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(RankingIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Relatórios')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(RelatoryIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Configurações')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(SettingIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class", "onMouseover", "onMouseleave"]))
          }), 128))
        ]),
        _createVNode(_component_v_spacer),
        _hoisted_7,
        (hasPermission.value)
          ? (_openBlock(), _createBlock(_unref(AtomButtonBar), {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModalSolicitation.value = true)),
              classes: "btn-service ma-4",
              text: "Solicitar serviço",
              "prepend-icon": true
            }, {
              prependIcon: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" mdi-plus-circle")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(AtomButtonBar), {
            classes: "btn-service ma-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LogoutIcon), { class: "mt-1 mb-1" })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(MoleculeModalAlert), {
      "show-alert-confirm": showModal.value,
      icon: 'LogoutIcon',
      text: "Deseja sair da sua conta?",
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false)),
      onConfirm: handleLogout
    }, null, 8, ["show-alert-confirm"]),
    (hasPermission.value)
      ? (_openBlock(), _createBlock(ModalSolicitation, {
          key: 0,
          btnConfirmText: "Solicitar",
          btnCloseText: "Cancelar",
          showModal: showModalSolicitation.value,
          onHiddenModal: _cache[3] || (_cache[3] = ($event: any) => (showModalSolicitation.value = false))
        }, null, 8, ["showModal"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})